import { createContext } from "react";
import { ContractRecruitment, RecruitmentRequest } from "../../types";

export interface IRecruitmentContext {
  recruitment?: ContractRecruitment;
  activeRequests?: RecruitmentRequest[];
}

export const RecruitmentContext = createContext<IRecruitmentContext>({});
